import React from 'react'
import ModalWrapper from './ModalWrapper'
import NewSectionContainer from '../../containers/sections/NewSectionContainer'

const NewSectionModal = (props) => (
  <div className='newSection-modal'>
    <ModalWrapper
      {...props}
      title='Add Classes'
      modalStyle='dark'
      showModalHeader={false}
    >
      <NewSectionContainer onCreated={props.onCreated} />

    </ModalWrapper>

  </div>

)
export default NewSectionModal
